import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import PropertiesTable from './PropertiesTable';
import PropertiesMobile from './PropertiesMobile';
import MediaQuery from 'react-responsive';
import TextField from 'material-ui/TextField';
import AbstractDialog from './dialog/AbstractDialog';

import * as landlordProperties from 'actions/landlordPropertiesActions';
import * as landlordTenants from 'actions/landlordTenantsActions';
import { showSuccess, showFailure } from 'actions/notificationActions';

import ConfirmationDialog from 'components/shared/ConfirmationDialog';
import { default as UIConfirmationDialog } from 'components/ui/Dialogs/ConfirmationDialog';
import DocumentUploader from 'components/shared/DocumentUploader';
import Documents from '../../rent_roll/components/options_popover/Documents';
import { AccentColor } from 'helpers/AccentColorHelper';
import { getTranslatedString } from 'helpers/i18n';
import FlatButton from 'material-ui/FlatButton';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import MaintenanceWaiver from './MaintenanceWaiver';
import DigitalLegalNotices from './DigitalLegalNotices';
import ProspectMessage from './ProspectMessage';
import GoogleReview from './GoogleReview/index';

export default connect(
  (store) => {
    return {
      properties: store.landlordProperties.properties,
      portfolios: store.landlordProperties.portfolios,
      accounts: store.landlordProperties.accounts,
      admin: store.userTypes.admin,
      googleEnabled: store.companyDetails.companyPreferences.google_reviews_active,
      legalNoticesEnabled: !!store.companyDetails.companyPreferences.enable_tenant_legal_notices,
      requestAssistanceEnabled: !!store.companyDetails.companyPreferences.enable_portal_assistance_request,
      minimumLandlordRating: store.companyDetails.companyPreferences.google_reviews_minimum_rating,
      showDocuments: store.landlordTenants.showDocuments,
    };
  },
  { ...landlordProperties, ...landlordTenants, showSuccess, showFailure }
)(
  class PropertiesNonGrid extends Component {
    constructor(props) {
      super(props);
      this.state = {
        data: [],
        error: '',
        filterText: '',
        AbstractDialog: {
          show: false,
          type: null,
          data: null,
        },
        showDeleteDialog: false,
        showInvitableDialog: false,
        showLegalNoticesDialog: false,
        showRequestAssistanceDialog: false,
        requestAssistanceDialogState: 'confirm',
        documentUploaderDialogOpen: false,
        propertyId: null,
        propertyInvitable: true,
        maintenanceWaiverMessageDialogOpen: false,
        propertyMaintenanceWaiverMessage: null,
        propertyName: '',
      };

      const params = browserHistory.getCurrentLocation().query;
      if (!params.stripe_connected) return;

      if (params.stripe_connected === 'true') {
        this.props.showSuccess('successfullyConnectedStripe');
      } else if (params.stripe_connected === 'false') {
        this.props.showFailure('couldNotConnectToStripe');
      }

      browserHistory.push(browserHistory.getCurrentLocation().pathname);
    }

    UNSAFE_componentWillMount() {
      this.props.getPortfolios();
      this.props.getAccounts();
    }

    getFilterText = (e) => {
      this.setState({ filterText: e.target.value });
    };

    closeAbstractDialog = () => {
      this.setState({ AbstractDialog: { show: false } });
    };

    openAbstractDialog = (type, data) => {
      this.setState({
        AbstractDialog: {
          show: true,
          type: type,
          data: data,
        },
      });
    };

    assignPortfolio = (portfolioName, portfolio, property_id) => {
      const portfolioArray = this.props.portfolios.map((obj) => {
        return obj.label.toLowerCase();
      });

      if (
        portfolioArray.includes(portfolioName.toLowerCase()) &&
        portfolio === 'Create New Portfolio'
      ) {
        this.setState({ error: 'This portfolio already exists.' });
      } else if (portfolioName === '' && portfolio === 'Create New Portfolio') {
        this.setState({ error: 'Portfolio name cannot be blank.' });
      } else {
        this.props.assignPortfolio(portfolioName, portfolio, property_id);
        this.closeAbstractDialog();
      }
    };

    assignAccount = (account_params) => {
      this.props.assignAccount(account_params);
      this.closeAbstractDialog();
    };

    propertyDetails = (propertyId) => {
      this.props.getProperty(propertyId).then(() => {
        browserHistory.push('/companies/property_details');
      });
    };

    submitPropertyShowingPreferences = (formData) => {
      this.props.updatePropertyAvailability(formData);
    };

    toggleDeleteDialog = (propertyId) => {
      this.setState((prevState) => ({
        showDeleteDialog: !prevState.showDeleteDialog,
        propertyId: propertyId,
      }));
    };

    toggleLegalNoticesDialog = (propertyId) => {
      const property = this.props.properties.find((property) => property.id === propertyId);
      const canSendLegalNotices = property.can_send_legal_notices;

      this.setState((prevState) => ({
        showLegalNoticesDialog: !prevState.showLegalNoticesDialog,
        propertyId: propertyId,
        canSendLegalNotices,
      }));
    };

    inactivateProperty = (propertyId) => {
      return this.props.inactivateProperty(propertyId).then(() => {
        this.toggleDeleteDialog();
      });
    };

    toggleInvitableDialog = (propertyId, invitable = true) => {
      this.setState((prevState) => ({
        showInvitableDialog: !prevState.showInvitableDialog,
        propertyId: propertyId,
        propertyInvitable: invitable,
      }));
    };

    toggleDocumentUploaderDialog = (propertyId) => {
      this.setState((prevState) => ({
        documentUploaderDialogOpen: !prevState.documentUploaderDialogOpen,
        propertyId: propertyId,
      }));
    };

    toggleProspectMessageDialog = (propertyId) => {
      let selectedProperty = null;
      let prospectDialogMessage;
      let propertyName = '';
      if (!this.state.prospectMessageDialogOpen) {
        selectedProperty = this.props.properties.find((property) => property.id === propertyId);
        prospectDialogMessage = selectedProperty.application_message;
        propertyName = selectedProperty.name;
      }
      this.setState((prevState) => ({
        prospectMessageDialogOpen: !prevState.prospectMessageDialogOpen,
        propertyId: propertyId,
        propertyName: propertyName,
        prospectDialogMessage: prospectDialogMessage,
      }));
    };

    toggleGoogleReviewDialog = (propertyId) => {
      let selectedProperty = null;
      let minimumRating;
      let googleReviewActive = '';
      let googleReviewLink = '';

      if (!this.state.googleReviewDialogOpen) {
        selectedProperty = this.props.properties.find((property) => property.id === propertyId);
        minimumRating = selectedProperty.google_reviews_minimum_rating;
        googleReviewActive = selectedProperty.google_reviews_active;
        googleReviewLink = selectedProperty.google_review_link;
      }

      this.setState((prevState) => ({
        minimumRating,
        propertyId: propertyId,
        googleReviewLink,
        googleReviewDialogOpen: !prevState.googleReviewDialogOpen,
        googleReviewActive,
      }));
    };

    toggleMaintenanceWaiverMessageDialog = (propertyId) => {
      let selectedProperty = null;
      let propertyMaintenanceWaiverMessage;
      let propertyName = '';
      if (!this.state.maintenanceWaiverMessageDialogOpen) {
        selectedProperty = this.props.properties.find((property) => property.id === propertyId);
        propertyMaintenanceWaiverMessage = selectedProperty.maintenance_waiver_details;
        propertyName = selectedProperty.name;
      }
      this.setState((prevState) => ({
        maintenanceWaiverMessageDialogOpen: !prevState.maintenanceWaiverMessageDialogOpen,
        propertyId: propertyId,
        propertyName: propertyName,
        propertyMaintenanceWaiverMessage: propertyMaintenanceWaiverMessage,
      }));
    };

    toggleMaintenanceDispatchDialog = () => {
      this.setState((prevState) => ({
        maintenanceDispatchDialogOpen: !prevState.maintenanceDispatchDialogOpen,
      }));
    };

    updatePropertyInvitable = (propertyId) => {
      return this.props.updatePropertyInvitable(propertyId).then(() => {
        this.toggleInvitableDialog();
      });
    };

    renderLegalNoticesDialog = () => {
      const { toggleLegalNoticesDialog } = this;

      const { showLegalNoticesDialog, canSendLegalNotices, propertyId } = this.state;

      const {
        toggleDigitalLegalNotices, // API function from landlordPropertiesActions
        getProperties,
      } = this.props;

      return (
        <DigitalLegalNotices
          dialogOpen={showLegalNoticesDialog}
          toggleDialog={toggleLegalNoticesDialog}
          canSendLegalNotices={canSendLegalNotices}
          toggleLegalNotices={toggleDigitalLegalNotices}
          getProperties={getProperties}
          propertyId={propertyId}
        />
      );
    };

    _renderViewDocuments = () => {
      return (
        <Dialog
          fullScreen={this.props.fullScreen}
          open={this.props.showDocuments}
          onClose={() => {
            this.props.closeDocuments();
          }}
          aria-labelledby="documents"
          classes={{
            paper: 'form-dialog',
          }}
        >
          <DialogTitle id="documents">
            <h3 style={{ textAlign: 'center', margin: 0 }}>
              {' '}
              {getTranslatedString('landlordPortal.properties.documents')}{' '}
            </h3>
          </DialogTitle>
          <DialogContent>
            <Documents handleClose={this.props.closeDocuments} />
          </DialogContent>

          <DialogActions style={{ display: 'block' }}>
            <FlatButton
              onClick={this.props.closeDocuments}
              id="close-button"
              style={{ color: AccentColor() }}
            >
              {getTranslatedString('landlordPortal.rentRollNonGrid.close')}
            </FlatButton>
          </DialogActions>
        </Dialog>
      );
    };

    toggleRequestAssistanceDialog = (propertyId) => {
      this.setState((prevState) => ({
        showRequestAssistanceDialog: !prevState.showRequestAssistanceDialog,
        propertyId: propertyId,
        requestAssistanceDialogState: 'confirm'
      }), () => {
        this.props.getProperties();
      });
    };

    closeRequestAssistanceDialog = () => {
      this.setState({ showRequestAssistanceDialog: false }, () => {
        this.props.getProperties();
      });
    }

    handleToggleRequestAssistance = () => {
      this.setState({ requestAssistanceDialogState: 'loading' });
      this.props.toggleRequestAssistance(this.state.propertyId)
        .then(() => {
          this.setState({ requestAssistanceDialogState: 'success' });
        });
    }

    _renderAssistanceRequestDialog = () => {
      const property = this.props.properties.find((property) => property.id === this.state.propertyId);
      const actionName = property?.enable_portal_assistance_request ? 'disable' : 'enable';
      const actionLabel = getTranslatedString(`landlordPortal.properties.requestAssistance.${actionName}`);
      const closeLabel = getTranslatedString(`landlordPortal.properties.requestAssistance.close`);
      const title = getTranslatedString(`landlordPortal.properties.requestAssistance.${actionName}Title`);
      const description = getTranslatedString(`landlordPortal.properties.requestAssistance.${actionName}Explain`);
      const successHeader = getTranslatedString(`landlordPortal.properties.requestAssistance.${actionName}Message`);
      
      return (
        <UIConfirmationDialog
          showConfirmationDialog={this.state.showRequestAssistanceDialog}
          dialogState={this.state.requestAssistanceDialogState}
          confirm={{
            headerText: title,
            bodyText: description,
            primaryBtnText: actionLabel,
            primaryAction: this.handleToggleRequestAssistance,
            secondaryBtnText: closeLabel,
            secondaryAction: this.closeRequestAssistanceDialog,
          }}
          success={{
            headerText: successHeader,
            primaryBtnText: closeLabel,
            bodyText: description,
            action: this.closeRequestAssistanceDialog,
          }}
          loading={{
            headerText: getTranslatedString('landlordPortal.rentRoll.renewals.loadingHeader'),
            bodyText: getTranslatedString('landlordPortal.rentRoll.renewals.doNotReload'),
          }}
        />
      );
    }

    render() {
      const data = this.props.properties || [];
      const textFilter = this.state.filterText && this.state.filterText.toUpperCase();
      let filteredData = [];
      if (data && data.length > 0) {
        filteredData = data.filter((item) => {
          return (
            !textFilter ||
            (item.name && item.name.toUpperCase().includes(textFilter)) ||
            (item.owner_or_portfolio && item.owner_or_portfolio.toUpperCase().includes(textFilter))
          );
        });
      }

      const documentTypes = {
        'Frequently Used': ['Orientation Package', 'Notice'],
        Other: ['Other'],
      };

      return (
        <div ref="propertiesContainer">
          <AbstractDialog
            open={this.state.AbstractDialog.show}
            handleClose={this.closeAbstractDialog}
            type={this.state.AbstractDialog.type}
            data={this.state.AbstractDialog.data}
            portfolios={this.props.portfolios}
            assignPortfolio={this.assignPortfolio}
            accounts={this.props.accounts}
            assignAccount={this.assignAccount}
            error={this.state.error}
            submitPropertyShowingPreferences={this.submitPropertyShowingPreferences}
          />

          <ConfirmationDialog
            showDialog={this.state.showDeleteDialog}
            hideDialog={this.toggleDeleteDialog}
            userConfirmVerbiage="Delete Property"
            userConfirmAction={() => this.inactivateProperty(this.state.propertyId)}
            dialogTitle="Inactivate Property"
            dialogBodyVerbiage={this._renderDeleteProperty()}
            confirmationText="delete"
          />

          <ConfirmationDialog
            showDialog={this.state.showInvitableDialog}
            hideDialog={this.toggleInvitableDialog}
            userConfirmVerbiage={this.state.propertyInvitable ? 'disable' : 'enable'}
            userConfirmAction={() => this.updatePropertyInvitable(this.state.propertyId)}
            dialogTitle={
              this.state.propertyInvitable
                ? getTranslatedString('landlordPortal.properties.turnOffInvitations')
                : getTranslatedString('landlordPortal.properties.enableInvitations')
            }
            dialogBodyVerbiage={this._renderInvitableProperty()}
            confirmationText={
              this.state.propertyInvitable
                ? getTranslatedString('landlordPortal.properties.disable')
                : getTranslatedString('landlordPortal.properties.enable')
            }
          />

          <DocumentUploader
            documentTypes={documentTypes}
            dialogOpen={this.state.documentUploaderDialogOpen}
            toggleDialog={this.toggleDocumentUploaderDialog}
            handleSubmit={(data) => this.props.createPropertyDocument(data, this.state.propertyId)}
          />

          <MaintenanceWaiver
            dialogOpen={this.state.maintenanceWaiverMessageDialogOpen}
            toggleDialog={this.toggleMaintenanceWaiverMessageDialog}
            createMaintenanceWaiver={this.props.createMaintenanceWaiver}
            getProperties={this.props.getProperties}
            propertyId={this.state.propertyId}
            propertyName={this.state.propertyName}
            maintenanceWaiverDialogMessage={this.state.propertyMaintenanceWaiverMessage}
          />

          {this.renderLegalNoticesDialog()}
          {this._renderAssistanceRequestDialog()}

          <GoogleReview
            dialogOpen={this.state.googleReviewDialogOpen}
            toggleDialog={this.toggleGoogleReviewDialog}
            getProperties={this.props.getProperties}
            propertyId={this.state.propertyId}
            minimumRating={this.state.minimumRating}
            googleReviewLink={this.state.googleReviewLink}
            googleReviewActive={this.state.googleReviewActive}
            createGoogleReview={this.props.createGoogleReview}
            minimumLandlordRating={this.props.minimumLandlordRating}
          />

          <ProspectMessage
            dialogOpen={this.state.prospectMessageDialogOpen}
            toggleDialog={this.toggleProspectMessageDialog}
            createProspectMessage={this.props.createProspectMessage}
            getProperties={this.props.getProperties}
            propertyId={this.state.propertyId}
            propertyName={this.state.propertyName}
            prospectDialogMessage={this.state.prospectDialogMessage}
          />

          {this._renderViewDocuments()}

          <MediaQuery query="(min-device-width: 750px)">
            <div className="row" style={{ marginTop: '-20px' }}>
              <TextField
                hintText={getTranslatedString('landlordPortal.properties.filterBy')}
                style={{ fontSize: '13px' }}
                value={this.state.filterText}
                onChange={this.getFilterText}
              />
            </div>
            <PropertiesTable
              data={filteredData}
              admin={this.props.admin}
              abstractDialogVisible={this.state.AbstractDialog.show}
              openAbstractDialog={this.openAbstractDialog}
              propertyDetails={this.propertyDetails}
              inactivateProperty={this.inactivateProperty}
              toggleInvitableDialog={this.toggleInvitableDialog}
              toggleDeleteDialog={this.toggleDeleteDialog}
              toggleDocumentUploaderDialog={this.toggleDocumentUploaderDialog}
              openPropertyDocuments={this.props.openPropertyDocuments}
              showDeleteDialog={this.state.showDeleteDialog}
              showInvitableDialog={this.state.showInvitableDialog}
              showDocumentDialogs={
                this.state.documentUploaderDialogOpen || this.props.showDocuments
              }
              showMaintenanceWaiverMessageDialog={this.state.maintenanceWaiverMessageDialogOpen}
              toggleMaintenanceWaiverMessageDialog={this.toggleMaintenanceWaiverMessageDialog}
              showProspectMessageDialog={this.state.prospectMessageDialogOpen}
              toggleProspectMessageDialog={this.toggleProspectMessageDialog}
              toggleGoogleReviewDialog={this.toggleGoogleReviewDialog}
              showGoogleReviewDialog={this.state.googleReviewDialogOpen}
              googleEnabled={this.props.googleEnabled}
              toggleLegalNoticesDialog={this.toggleLegalNoticesDialog}
              showLegalNoticesDialog={this.state.showLegalNoticesDialog}
              legalNoticesEnabled={this.props.legalNoticesEnabled}
              showRequestAssistanceDialog={this.state.showRequestAssistanceDialog}
              requestAssistanceEnabled={this.props.requestAssistanceEnabled}
              toggleRequestAssistanceDialog={this.toggleRequestAssistanceDialog}
            />
          </MediaQuery>
          <MediaQuery query="(max-device-width: 750px)">
            <PropertiesMobile
              data={filteredData}
              admin={this.props.admin}
              abstractDialogVisible={this.state.AbstractDialog.show}
              openAbstractDialog={this.openAbstractDialog}
              propertyDetails={this.propertyDetails}
              inactivateProperty={this.inactivateProperty}
              toggleInvitableDialog={this.toggleInvitableDialog}
              toggleDeleteDialog={this.toggleDeleteDialog}
              showDeleteDialog={this.state.showDeleteDialog}
              showInvitableDialog={this.state.showInvitableDialog}
              toggleDocumentUploaderDialog={this.toggleDocumentUploaderDialog}
              openPropertyDocuments={this.props.openPropertyDocuments}
              showDocumentDialogs={
                this.state.documentUploaderDialogOpen || this.props.showDocuments
              }
              showMaintenanceWaiverMessageDialog={this.state.maintenanceWaiverMessageDialogOpen}
              toggleMaintenanceWaiverMessageDialog={this.toggleMaintenanceWaiverMessageDialog}
              toggleProspectMessageDialog={this.toggleProspectMessageDialog}
              showProspectMessageDialog={this.state.prospectMessageDialogOpen}
              toggleGoogleReviewDialog={this.toggleGoogleReviewDialog}
              showGoogleReviewDialog={this.state.googleReviewDialogOpen}
              googleEnabled={this.props.googleEnabled}
              toggleLegalNoticesDialog={this.toggleLegalNoticesDialog}
              showLegalNoticesDialog={this.state.showLegalNoticesDialog}
              legalNoticesEnabled={this.props.legalNoticesEnabled}
              showRequestAssistanceDialog={this.state.showRequestAssistanceDialog}
              requestAssistanceEnabled={this.props.requestAssistanceEnabled}
              toggleRequestAssistanceDialog={this.toggleRequestAssistanceDialog}
            />
          </MediaQuery>
        </div>
      );
    }

    _renderDeleteProperty = () => {
      return (
        <div>
          <p>
            <span style={{ color: '#ff3030' }}>
              {getTranslatedString('landlordPortal.properties.warning')}
            </span>{' '}
            {getTranslatedString('landlordPortal.properties.byInactivating')}
          </p>
        </div>
      );
    };

    _renderInvitableProperty = () => {
      if (this.state.propertyInvitable) {
        return (
          <div>
            <p>
              <span style={{ color: '#ff3030' }}>
                {getTranslatedString('landlordPortal.properties.warning')}
              </span>{' '}
              {getTranslatedString('landlordPortal.properties.byTurningOff')}
            </p>
          </div>
        );
      }

      return (
        <div>
          <p>
            <span style={{ color: '#ff3030' }}>
              {getTranslatedString('landlordPortal.properties.warning')}
            </span>{' '}
            {getTranslatedString('landlordPortal.properties.byTurningOn')}
          </p>
        </div>
      );
    };
  }
);
